import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { GridItem, useToken } from '@chakra-ui/react';
import { TableEditableValue, TableValue } from '../../../../../components';
const TableCellFC = ({ column, rowId, rowKey, rowValue, rowConfig, isFirst, isLast, isReadOnly, isInvalid, noBg, cellSx, textOverflow = true, onValueChange }) => {
    const [borderHex] = useToken('colors', ['border']);
    // TODO: all sticky styles should be in parent component
    const getCellStyles = useCallback(() => {
        let styles = {};
        if (textOverflow) {
            styles.textOverflow = 'ellipsis';
            styles.whiteSpace = 'nowrap';
            styles.overflow = 'hidden';
        }
        if (column.sticky && isFirst) {
            styles = {
                ...styles,
                position: 'sticky',
                zIndex: 1,
                left: 0,
                borderRight: `1px solid ${borderHex}`
            };
        }
        if (column.sticky && isLast) {
            styles = {
                ...styles,
                position: 'sticky',
                zIndex: 1,
                right: 0,
                borderLeft: `1px solid ${borderHex}`
            };
        }
        return styles;
    }, [borderHex, column.sticky, isFirst, isLast, textOverflow]);
    const cellConfig = useMemo(() => {
        const cellOptions = column.propertyName ? (rowConfig?.[column.propertyName] ?? {}) : {};
        return {
            required: column.required,
            readOnly: column.readOnly,
            type: column.type,
            unit: column.unit,
            options: column.options || [],
            ...cellOptions
        };
    }, [
        column.options,
        column.propertyName,
        column.readOnly,
        column.required,
        column.type,
        column.unit,
        rowConfig
    ]);
    return (_jsxs(GridItem, { minH: "24px", bg: noBg ? 'white' : 'bg', p: rowId === 0 ? '4px 2px 2px' : '2px', alignContent: "center", textAlign: column.align === 'right' ? 'right' : 'left', sx: { ...getCellStyles(), ...cellSx }, children: [column.render?.(rowId, rowValue, column, rowKey), !column.render && (_jsx(_Fragment, { children: cellConfig.type ? (_jsx(TableEditableValue, { value: column.propertyName ? rowValue[column.propertyName] : '', isDisabled: !!isReadOnly || !!cellConfig.readOnly, type: cellConfig.type ?? 'string', options: cellConfig.options ?? [], unit: cellConfig.unit, isInvalid: isInvalid, onChangeValue: (newValue) => {
                        onValueChange?.(newValue);
                    } })) : (_jsx(TableValue, { isFormula: column.formula || rowConfig?.[column.propertyName ?? '']?.formula, isDisabled: !!isReadOnly || !!cellConfig.readOnly, value: column.propertyName ? rowValue[column.propertyName] : '' })) }))] }));
};
export const TableCell = memo(TableCellFC);
//# sourceMappingURL=TableCell.js.map